export default {
    'newsletter.title': 'Be the first to know',
    'newsletter.btn': 'Subscribe',
    'newsletter.placeholder': 'Your email',
    'newsletter.subtitle': 'Stay informed and be the first to know about news!',
    'instagram.title': 'Follow us',
    'contact.title': 'Need help?',
    'contact.hours': 'Mon - Fri: 9:00 - 19:00',
    'login.title': 'Account login',
    'cart.orderRecap': 'Order recap',
    "cart.empty": "Your cart is empty",
    "cart.back": "Back to shop",
    "prefix": 'By submitting the message you agree with ',
    "privacy": 'the privacy policy'
}
